import { useCallback, useRef } from "react";
import api from "@/lib/api";

/**
 * Returns a handler that updates a ZIP field immediately and, when a valid
 * 5-digit ZIP is entered, debounce-fetches city/state from the backend and
 * fills the given city/state form keys.
 */
export function useZipAutofill(setForm) {
  const timers = useRef({});
  return useCallback(
    (value, { zipKey, cityKey, stateKey }) => {
      setForm((f) => ({ ...f, [zipKey]: value }));
      clearTimeout(timers.current[zipKey]);
      if (/^\d{5}$/.test(value)) {
        timers.current[zipKey] = setTimeout(async () => {
          try {
            const { data } = await api.get(`/geo/zip/${value}`);
            if (data?.city) {
              setForm((f) =>
                String(f[zipKey]) === value
                  ? { ...f, [cityKey]: data.city, [stateKey]: data.state_abbr }
                  : f,
              );
            }
          } catch {
            /* silent — ZIP not found / offline */
          }
        }, 450);
      }
    },
    [setForm],
  );
}
